import { Box, useTheme } from "@mui/material"
import { Keyboard } from "components/Keyboard"

export const SearchKeyboard = ({
  value = "",
  onChange,
  topKeywordAdornment = null,
  bottomKeywordAdornment = null,
}) => {
  const theme = useTheme()
  const { root } = theme.components[`VuiSearchKeyboard`]?.styleOverrides || {}

  return (
    <Box className="VuiSearchKeyboard-root" sx={root}>
      {topKeywordAdornment}
      <Keyboard inputValue={value} onChange={onChange} />
      {bottomKeywordAdornment}
    </Box>
  )
}
